// Detect and recover from cases where the UI becomes non-interactive after history navigation.
// This is a last-resort safety net.

(function () {
  function isBlazorAvailable() {
    return typeof window.Blazor !== 'undefined';
  }

  function scheduleModalArtifactCleanup() {
    try {
      if (window.bootstrapModalCleanup?.closeAllModalsAfterNavigation) {
        window.bootstrapModalCleanup.closeAllModalsAfterNavigation();
      }
    } catch {
      // ignore
    }
  }

  // On history navigation, ensure no overlays remain.
  window.addEventListener('popstate', () => {
    // Do not prevent default; let Blazor handle it.
    setTimeout(scheduleModalArtifactCleanup, 0);
    setTimeout(scheduleModalArtifactCleanup, 50);
  });

  // If we ever detect that clicks are being blocked by an overlay (no console errors), clean up.
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!target) return;

    // If clicking on a backdrop or a hidden modal shell, remove artifacts.
    const backdrop = target.closest?.('.modal-backdrop');
    const modalShell = target.closest?.('.modal');

    if (backdrop || (modalShell && !modalShell.classList.contains('show'))) {
      setTimeout(scheduleModalArtifactCleanup, 0);
    }
  }, true);
})();
